import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccountFragmentFragment, DataRoomFile } from "../../graphql/generated";
import { StateError } from "../error";

export type Actor = {
  account: Pick<AccountFragmentFragment, "id" | "name" | "email" | "avatar">;
  dealAccountId: string;
};

export type AuthState = {
  isLoggedIn: boolean;
  isLoading: boolean;
  accessToken?: string;
  refreshToken?: string;
  error: StateError;
  account?: AccountFragmentFragment;
  dealsLastSeen: { [dealId: string]: number };
  actor?: Actor;
  activeDealId?: string;
  navigationCollapsed: boolean;

  // BIG HACK
  staffSheetQuestionAnswer?: {
    file: DataRoomFile;
    answer: string;
  };
};

const initialState: AuthState = {
  isLoggedIn: false,
  isLoading: false,
  error: null,
  dealsLastSeen: {},
  navigationCollapsed: false,
};

export const { actions, reducer } = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (
      state,
      action: PayloadAction<{
        tokens: { accessToken: string; refreshToken: string };
        account: AccountFragmentFragment;
      }>,
    ) => {
      state.isLoading = false;
      state.isLoggedIn = true;
      state.accessToken = action.payload.tokens.accessToken;
      state.refreshToken = action.payload.tokens.refreshToken;
      state.account = action.payload.account;
    },
    loginFailure: (state) => {
      state.isLoading = false;
      state.isLoggedIn = false;
      state.accessToken = undefined;
      state.refreshToken = undefined;
    },
    logout: (state) => initialState,
    refreshAccount: (
      state,
      action: PayloadAction<{ account: AccountFragmentFragment }>,
    ) => {
      state.account = action.payload.account;
    },
    setAccessToken: (state, action: PayloadAction<{ token: string }>) => {
      state.accessToken = action.payload.token;
    },
    setActor(
      state,
      action: PayloadAction<{
        actor: Actor | undefined;
      }>,
    ) {
      state.actor = action.payload.actor;
    },
    setActiveDealId(
      state,
      action: PayloadAction<{ dealId: string | undefined }>,
    ) {
      state.activeDealId = action.payload.dealId;
    },

    // more hack
    setStaffSheetQuestionAnswer(
      state,
      action: PayloadAction<{
        answer: {
          file: DataRoomFile;
          answer: string;
        };
      }>,
    ) {
      state.staffSheetQuestionAnswer = action.payload.answer;
    },
    setNavigationCollapsed(
      state,
      action: PayloadAction<{ collapsed: boolean }>,
    ) {
      state.navigationCollapsed = action.payload.collapsed;
    },
  },
});
